import * as z from 'zod/v4-mini'

/**
 * Guards what comes back out of localStorage. Anything that fails — a shape
 * change, a hand-edited value, a half-written record — resets the basket
 * instead of throwing inside a component render.
 *
 * Zod Mini, not classic Zod. Classic Zod ships its whole class tree for any one
 * schema, and the basket store loads with every page — so this guard was the
 * reason the full library was on the consumer app's critical path. Mini is the
 * same validator with tree-shakable functions, and carries only what is used.
 */
const priceSchema = z.object({
  amount: z.number(),
  currency: z.string(),
  formatted: z.string()
})

const basketAddonSchema = z.object({
  id: z.string(),
  name: z.string(),
  price: priceSchema,
  quantity: z.nullable(z.int().check(z.minimum(1))),
  maxQuantity: z.nullable(z.int().check(z.minimum(1)))
})

const basketLineSchema = z.object({
  key: z.string(),
  menuItemId: z.number(),
  slug: z.string(),
  name: z.string(),
  imageUrl: z.nullable(z.string()),
  unitPrice: priceSchema,
  quantity: z.int().check(z.minimum(1)),
  addons: z.array(basketAddonSchema),
  notes: z.nullable(z.string())
})

export const basketSnapshotSchema = z.object({
  schemaVersion: z.number(),
  siteSlug: z.string(),
  idempotencyKey: z.string(),
  updatedAt: z.number(),
  lines: z.array(basketLineSchema)
})
